module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.school) ? _c('div', [(_vm.schoolTitle) ? _c('h1', [_vm._v(_vm._s(_vm.school.name))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editable_fields), function(field) {
    return _c('div', {}, [_c('pl-input', {
      attrs: {
        "labelText": ("Edit: " + field)
      },
      model: {
        value: (_vm.school[field]),
        callback: function($$v) {
          _vm.$set(_vm.school, field, $$v)
        },
        expression: "school[field]"
      }
    })], 1)
  }), _vm._v(" "), _c('div', [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Save Settings\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.non_editable_fields), function(field) {
    return _c('div', {}, [_c('span', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v(_vm._s(field))]), _vm._v(" : " + _vm._s(_vm.school[field]))])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pl-display-1"
  }, [_vm._v("Invite code")]), _vm._v(" "), (_vm.school.invites.length) ? [_c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n      This is the code that admins can share with teachers so teachers can\n      join parlay under the school\n      "), _c('br'), _vm._v("\n      You can edit here to make it more customized. The code must be between\n      4-10 characters. The code cannot be the same as the code for any other\n      schools.\n      "), _c('pl-input', {
    attrs: {
      "placeholder": "Edit the code here"
    },
    model: {
      value: (_vm.school.invites[0].code),
      callback: function($$v) {
        _vm.$set(_vm.school.invites[0], "code", $$v)
      },
      expression: "school.invites[0].code"
    }
  })], 1), _vm._v(" "), _c('div', [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.editInviteCode.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Save Code\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4 pl-display-1"
  }, [_vm._v("Email Suffix")]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n      Here you can edit the schools email suffix. This means that whenever a\n      teacher tries to updgrade their account with a school code, they will\n      only be allowed to do so if their email contains the suffix you've\n      specified. If you don't specify anything, anyone can use the code\n      "), _c('multiselect', {
    staticStyle: {
      "max-width": "100%",
      "height": "100%"
    },
    attrs: {
      "placeholder": "All Emails Suffixes",
      "tag-placeholder": "Add this as Email Suffix",
      "options": _vm.email_suffixes,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addEmailSuffix,
      "remove": _vm.deleteEmailSuffix
    },
    model: {
      value: (_vm.selected_email_suffixes),
      callback: function($$v) {
        _vm.selected_email_suffixes = $$v
      },
      expression: "selected_email_suffixes"
    }
  })], 1), _vm._v(" "), _c('div', [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.editEmailSuffix.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Save Email Suffix\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4 pl-display-1"
  }, [_vm._v("Invite Link")]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n      Teachers can use this link to sign up directly under a school the moment\n      they register for parlay.\n      "), _c('br'), _vm._v("\n      NOTE: If you changed the code, make sure to save it before copying and\n      sharing the link below.\n      "), _c('br'), _vm._v("\n      Link: "), _c('strong', [_vm._v(_vm._s(_vm.sharable_signup_link))])]), _vm._v(" "), _c('div', {
    staticClass: "mt4 pl-display-1"
  }, [_vm._v("Ed.Link Integrations")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "mt2 ml2",
    attrs: {
      "sync": true,
      "labels": true,
      "value": _vm.edlink_integration_enabled,
      "color": "#72ccd7"
    },
    on: {
      "change": function($event) {
        return _vm.toggleEdLinkConnection($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pl-display-1 mt3"
  }, [_vm._v("Admin Portal Link")]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading"
  }, [_c('div', [_vm._v("Teachers can use this link directly to the admin portal.")]), _vm._v("\n      Link:\n      "), _c('strong', [_vm._v(_vm._s(_vm.admin_portal_link))])])] : [_c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n      This school has no invite code as of yet. Create one below....\n    ")]), _vm._v(" "), _c('pl-input', {
    attrs: {
      "placeholder": "Insert the new code here"
    },
    model: {
      value: (_vm.new_invite_code),
      callback: function($$v) {
        _vm.new_invite_code = $$v
      },
      expression: "new_invite_code"
    }
  }), _vm._v(" "), _c('div', [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.createInviteCode.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Create Code\n      ")])], 1)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-43801d4c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/individualSchoolTabs/editSchoolInfo.vue
// module id = 1976
// module chunks = 61